import {ComponentRef, EventEmitter} from "@angular/core";
import {ModalContext} from "./ModalContext";
import {IModalOptions} from "./IModalOptions";
import {NModalLayerComponent} from "./components/public_components";

export class ModalInstance<T> {
  static topModalCssClass = "last-modal-window";
  static stashCssClass = "_stashed";

  result: Promise<T>;
  dismiss = new EventEmitter<any>();
  onUnstash = new EventEmitter<any>();

  private resolve: Function;
  private reject: Function;
  private closed: boolean;

  constructor(private component: ComponentRef<NModalLayerComponent>,
              private modalContext: ModalContext<any, any>,
              stashed: boolean) {
    this.result = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });

    modalContext.onDone = result => this.done(result);
    modalContext.onCancel = (reason?: any) => this.close(reason);
    if (stashed) {
      this.stash();
    }
  }

  get componentRef(): ComponentRef<any> {
    return this.modalContext.instance;
  }

  get options(): IModalOptions {
    return this.modalContext.options;
  }

  get window(): ComponentRef<NModalLayerComponent> {
    return this.component;
  }

  private _stashed: boolean;

  get stashed(): boolean {
    return this._stashed;
  }

  async close(reason?: any) {
    if (this.closed) {
      return true;
    }
    const canCloseModal = await this.closeModal();
    if (canCloseModal) {
      this.reject(reason);
    }
    return canCloseModal;
  }

  async done(result: T) {
    if (this.closed) {
      return true;
    }
    const canCloseModal = await this.closeModal();
    if (canCloseModal) {
      this.resolve(result);
    }
    return canCloseModal;
  }

  ensureComponent(): Promise<ComponentRef<any>> {
    return this.modalContext.ensureInstance();
  }

  focus() {
    // TODO force reflow this.component.location.nativeElement.focus();
  }

  markAsLast(last: boolean) {
    if (last) {
      this.component.location.nativeElement.classList.add(ModalInstance.topModalCssClass);
    } else {
      this.component.location.nativeElement.classList.remove(ModalInstance.topModalCssClass);
    }
  }

  stash() {
    if (this.stashed || this.modalContext.destroyed) {
      return;
    }
    this._stashed = true;
    this.component.location.nativeElement.classList.add(ModalInstance.stashCssClass);
  }

  /**
   * Move from stash (make visible)
   */
  unstash() {
    if (!this.stashed || this.modalContext.destroyed) {
      return;
    }
    this._stashed = false;
    this.component.location.nativeElement.classList.remove(ModalInstance.stashCssClass);
    this.onUnstash.emit();
    this.window.location.nativeElement.focus();
  }

  private closeModal(): Promise<boolean> {
    const instance = this.componentRef ? this.componentRef.instance : null;
    let canCloseIdle: Promise<any> = Promise.resolve(true);
    if (this.options.beforeClose) {
      canCloseIdle = canCloseIdle.then(async () => {
        await this.options.beforeClose();
        return true;
      });
    }
    if (instance && instance["canCloseModal"]) {
      canCloseIdle = instance["canCloseModal"]();
    }
    return canCloseIdle.then((value) => {
      if (value) {
        this.destroyModal();
      }
      return value;
    });
  }

  private destroyModal() {
    this.closed = true;
    this.dismiss.emit();
    this.component.destroy();
    this.modalContext.destroy();
  }

}
